<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_INDUSTRY_ID'
        )
      }"
    >
      <select
        v-model="$parent.project.UF_INDUSTRY_ID"
        class="sel-dropdown i-main-style i-wid-29"
        :disabled="is_disabled || $parent.$parent.projectDisabled"
        v-on:change="purchasedEquipmentList"
      >
        <option value></option>
        <option
          v-for="item in $parent.directory.tree_industry"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-if="isAllowed(item)"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_INDUSTRY_ID")
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "uf_industry_id_markirovka",
  props: ["is_disabled", "project"],
  data() {
    return {
      item: [],
      itemMoloko: []
    };
  },
  computed: {
    ...mapGetters(["directory"]),
    purchasedEquipment() {
      let t = this.directory.tree_industry.filter(
        c => c.ID === this.$parent.project.UF_INDUSTRY_ID
      );
      if (t.length > 0) {
        console.log("UF_INDUSTY_ID.CODE: ", t[0].CODE);
        return t[0].CODE;
      }
      return "";
    }
  },
  methods: {
    isAllowed(item) {
      if (
        this.$parent.project.UF_SETTING.IS_VIEW_TWO_VERSION_INDUSTRIAL == 1 &&
        this.$parent.$parent.getProgramCode(
          this.$parent.project.UF_SUPPORT_PROG_ID
        ) === "lekarstva"
      ) {
        switch (item.CODE) {
          case 21:
            return true;
          case "markirovka_other":
            return true;
          default:
            return false;
        }
      } else {
        if (
          this.$parent.$parent.getProgramCode(
            this.$parent.project.UF_SUPPORT_PROG_ID
          ) !== "working" &&
          this.$parent.$parent.getProgramCode(
            this.$parent.project.UF_SUPPORT_PROG_ID
          ) !== "working_rfrp"
        )
          switch (item.CODE) {
            case 17:
              return true;
            case 21:
              return true;
            case 22:
              return true;
            case 25:
              return true;
            case 37:
              return true;
            case 38:
              return true;
            case "markirovka_other":
              return true;
            default:
              return false;
          }
      }
    },
    purchasedEquipmentList() {
      if (
        this.purchasedEquipment !== 21 &&
        this.$parent.project.UF_INDUSTRY_ID !== ""
      ) {
        this.item = this.project.PURCHASED_EQUIPMENT.items.splice(0);
        // for (let i = 0; i < item.length; i++) {
        //   this.project.PURCHASED_EQUIPMENT.items.push(item[i])
        // }
        //     // this.project.PURCHASED_EQUIPMENT.items.push([...items])
        for (let i = 0; i < this.itemMoloko.length; i++) {
          this.project.PURCHASED_EQUIPMENT.items.unshift(this.itemMoloko[i]);
        }
      } else if (this.$parent.project.UF_INDUSTRY_ID === "") {
        this.project.PURCHASED_EQUIPMENT.items.splice(0);
      } else if (this.purchasedEquipment === 21) {
        this.itemMoloko = this.project.PURCHASED_EQUIPMENT.items.splice(0);
        if (this.item.length > 0) {
          for (let i = 0; i < this.item.length; i++) {
            this.project.PURCHASED_EQUIPMENT.items.unshift(this.item[i]);
          }
        }
      }
      // console.log("this.item: ", JSON.parse(JSON.stringify(this.item)));
      // console.log(
      //   "this.itemMoloko: ",
      //   JSON.parse(JSON.stringify(this.itemMoloko))
      // );
      // console.log(
      //   "this.project.PURCHASED_EQUIPMENT.items: ",
      //   JSON.parse(JSON.stringify(this.project.PURCHASED_EQUIPMENT))
      // );

      this.$parent.$parent.removeError("PROJECTS", "LOGIC", "UF_INDUSTRY_ID");
    }
  }
};
</script>

<style scoped></style>
